<template>
  <div class="login-container">
    <h1 class="login-title">{{title === 'mobiletv' ? $t("global.title") : $t('login.chinatv_system')}}</h1>
    <form class="login-form clearfix" @submit.prevent="login()">
      <input type="text" :placeholder="$t('login.user_name')" required v-model="form.account" @change="pswAutoFill()">
      <input type="password" :placeholder="$t('login.password')" required v-model="form.password">
      <div class="remember-psw">
        <input type="checkbox" id="c1" v-model="form.rememberPass">
        <label for="c1">{{$t('login.remember_password')}}</label>
      </div>
      <input class="login-submit" type="submit" :value="$t('login.login')">
    </form>
  </div>
</template>

<script>
  export default {
    data(){
      var application = document.querySelector('meta[name="application-name"]')
      return {
        form:{
          'account':'',
          'password':'',
          'rememberPass':false
        },
        title:application && application.getAttribute('content'),
        userInfo: {},
      }
    },
    mounted() {
    },
    methods:{
      login(){

        this.$http.post('/ams/admin/login',JSON.stringify(this.form)).then((res)=>{
          this.userInfo.username = res.body.data.username;
          this.userInfo.role = res.body.data.role;
          localStorage.setItem('userinfo',JSON.stringify(this.userInfo));

          if (res.data.err_code === 0) {
          var date=new Date();
          var expireDays=10;
          //将date设置为10天以后的时间
          date.setTime(date.getTime()+expireDays*24*3600*1000);
            document.cookie="token="+res.data.data.token+";expire="+date.toGMTString();
            if(this.$route.query.ret) {
              this.$router.push(this.$route.query.ret);
            } else {
              this.$router.push({name: 'home'})
            }
          }else{
            // window.alert(res.data.err_msg)
            this.$notify({
              title: 'Error',
              message: res.data.err_msg,
              type: 'error'
            })
          }
        })
      },
      getCookieValueByKey(key){
        return document.cookie.replace(new RegExp('(?:(?:^|.*;\\s*)'+ key +'\\s*\\=\\s*([^;]*).*$)|^.*$'), "$1")
      },
      pswAutoFill(){
        this.form.password = this.getCookieValueByKey(this.form.account);
        this.form.rememberPass=!!(this.getCookieValueByKey('rememberPass'));
      }
    },
    ready(){
      var username = this.getCookieValueByKey('username')
      if(username !== ''){
        this.form.account = username;
        this.form.password = this.getCookieValueByKey(username)
        this.form.rememberPass = !!(this.getCookieValueByKey('rememberPass'))
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '@/assets/css/varible.less';
  .login-container{
    width: 100%;
    height: 100%;
    background-color: #30455a;
    overflow-y: auto;
  }
  .login-title{
    margin-top: 250px;
    text-align: center;
    color: #fff;
    font-size: 30px;
  }
  .login-form {
    width:280px;
    margin:0 auto;
  }
  input[type="text"],input[type="password"]{
    width: 100%;
    height: 35px;
    margin: 15px 0;
    padding-left: 10px;
  }
  .verification-code {
    input{
      float: left;
      width: 150px;
      height: 35px;
    }
    img{
      width: 120px;
      height: 35px;
      margin: 15px 0;
      float: right;
    }
  }
  .remember-psw{
    float: left;
    margin-top: 18px;
    .checkbox();
  }
  .login-submit{
    float: right;
    width: 100px;
    height: 50px;
    font-size: 18px;
    background-color: #1fb9db;
    color: #fff;
    border-radius: 8px;
  }
</style>
